export const validateEmail = (email: string): boolean => {
    const regularExpression =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return regularExpression.test(email.toLowerCase());
};
